export default __webpack_public_path__ + "static/media/fb.a1c46323.png";